import React, { createContext, useContext } from 'react'
import { I18n } from 'i18n-js'
import locales from 'configs/locales.json'

const I18nContext = createContext()

const I18nProvider = ({ children }) => {
  const i18n = new I18n(locales)

  i18n.defaultLocale = 'cs'
  i18n.locale = 'cs'

  i18n.pluralization.register('cs', (_i18n, count) => {
    let key

    if (count === 1) {
      key = 'one'
    } else if (count >= 2 && count < 5) {
      key = 'few'
    } else {
      key = 'other'
    }

    return [key]
  })

  // i18n.onChange(() => {})

  return <I18nContext.Provider value={i18n}>{children}</I18nContext.Provider>
}

export { I18nContext, I18nProvider }
export default I18nContext
